module.exports = __webpack_public_path__ + "img/webpay.217be64.png";